import * as React from 'react';
import { Row, Col, Button, Modal } from 'react-bootstrap';
import notify from '../../../../../../shared/feedback/notifications';
import { handleError } from '../../../../../../shared/ErrorCatching';
import { Translate } from '../../../../../../shared/LanguageService';
import { assign } from '../../../../../../shared/Assign';
import Api from './Api';
import { IOrder, ISearchResultItem } from './Types';
import Search from './SearchForm';
import Order from './OrderDisplay';

interface IProps {
    orderId: number;
    close: (otherOrderId?: number) => void;
}

interface IState {
    firstOrder: IOrder;
    secondOrder: IOrder;
    verificationState: number;
    doButtonStyle: string;
}

export class SwapModal extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            firstOrder: null,
            secondOrder: null,
            verificationState: 0,
            doButtonStyle: 'default'
        };

        this.getSecondOrder = this.getSecondOrder.bind(this);
        this.swap = this.swap.bind(this);
    }

    componentDidMount() {
        Api.getFirstPlanOrder(this.props.orderId).then((order: IOrder) => {
            this.setState({ firstOrder: order } as IState);
        });
    }

    render() {
        return (
            <Modal show={true} onHide={() => this.props.close()} bsSize="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {Translate('order/plan/swap/order-compare/modal/title')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col xs={6} />
                        <Col xs={6}>
                            <Search selected={this.getSecondOrder} />
                        </Col>
                    </Row>
                    <Row>
                        {this.state.firstOrder && <Order order={this.state.firstOrder} />}
                        {this.state.secondOrder && <Order order={this.state.secondOrder} />}
                    </Row>
                    <Row className="button-row"></Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        bsStyle={this.state.doButtonStyle}
                        disabled={
                            !this.state.secondOrder ||
                            this.state.verificationState === -1 ||
                            this.state.verificationState === 0
                        }
                        onClick={this.swap}
                    >
                        <i className="material-icons md-18">swap_horiz</i>{' '}
                        {Translate('order/plan/swap/buttons/do/text')}
                    </Button>
                    <Button onClick={() => this.props.close()}>
                        {Translate('order/plan/swap/order-compare/modal/close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    getDoButtonClassName(verificationState: number): string {
        switch (verificationState) {
            case 0:
                return 'default';
            case 1:
                return 'warning';
            case 2:
                return 'success';
            default:
                break;
        }

        return 'default';
    }

    copyValidationToFirstOrder(secondOrder: IOrder) {
        let firstOrder = assign({}, this.state.firstOrder) as IOrder;
        firstOrder.brokerAgent.same = secondOrder.brokerAgent.same;
        firstOrder.brokerFirm.same = secondOrder.brokerFirm.same;
        firstOrder.planEditor.same = secondOrder.planEditor.same;
        firstOrder.planFirm.same = secondOrder.planFirm.same;
        this.setState({ firstOrder } as IState);
    }

    getSecondOrder(selection: ISearchResultItem): void {
        Api.getSecondPlanOrder(this.props.orderId, selection.value).then((result: IOrder) => {
            this.copyValidationToFirstOrder(result);
            return this.setState({ secondOrder: result } as IState, () => {
                Api.verify(this.state.firstOrder.id, this.state.secondOrder.id)
                    .then((result: number) =>
                        this.setState({
                            verificationState: result,
                            doButtonStyle: this.getDoButtonClassName(result)
                        } as IState)
                    )
                    .catch((error: any) =>
                        handleError(error, () =>
                            this.setState({
                                verificationState: -1,
                                doButtonStyle: this.getDoButtonClassName(-1)
                            } as IState)
                        )
                    );
            });
        });
    }

    swap(): void {
        Api.do(this.state.firstOrder.id, this.state.secondOrder.id)
            .then(() => notify.success(Translate('order/plan/swap/success')))
            .then(() => this.props.close(this.state.secondOrder.id))
            .catch((error: any) =>
                handleError(error, () =>
                    this.setState({
                        verificationState: -1,
                        doButtonStyle: this.getDoButtonClassName(-1)
                    } as IState)
                )
            );
    }
}

export default SwapModal;
